import { IHolidayDataObject } from "../interfaces/holiday"
import { ErrorPayLoad } from "../interfaces/purchase"
import { Types } from "../types"
import { AddHolidayError, AddHolidayRequest, AddHolidaySuccess, GetHolidayError, GetHolidayRequest, GetHolidaySuccess, RemoveHolidayError, RemoveHolidayRequest, RemoveHolidaySuccess, UpdateHolidayError, UpdateHolidayRequest, UpdateHolidaySuccess } from "../types/CalendarHolidy/actionType"
import { HolyDayType } from "../types/CalendarHolidy/apiRequestTypes"
import { GetListPublicParamsType } from "../types/common/commonTypes"





export const getHolidayRequestAction = (payload: GetListPublicParamsType): GetHolidayRequest => ({
    type: Types.GET_HOLIDAY_REQUEST,
    payload

})

export const getHolidaySuccessAction = (response: IHolidayDataObject): GetHolidaySuccess => ({
    type: Types.GET_HOLIDAY_SUCCESS,
    response
})

export const getHolidayErrorAction = (payload: ErrorPayLoad): GetHolidayError => ({
    type: Types.GET_HOLIDAY_ERROR,
    payload
})



export const AddHolidayRequestAction = (payload: HolyDayType): AddHolidayRequest => ({
    type: Types.ADD_HOLIDAY_REQUEST,
    payload
})

export const AddHolidaySuccessAction = (): AddHolidaySuccess => ({
    type: Types.ADD_HOLIDAY_SUCCESS,
})

export const AddHolidayErrorAction = (payload: ErrorPayLoad): AddHolidayError => ({
    type: Types.ADD_HOLIDAY_ERROR,
    payload
})



export const UpdateHolidayRequestAction = (payload: HolyDayType): UpdateHolidayRequest => ({
    type: Types.UPDATE_HOLIDAY_REQUEST,
    payload

})

export const UpdateHolidaySuccessAction = (): UpdateHolidaySuccess => ({
    type: Types.UPDATE_HOLIDAY_SUCCESS,
})

export const UpdateHolidayErrorAction = (payload: ErrorPayLoad): UpdateHolidayError => ({
    type: Types.UPDATE_HOLIDAY_ERROR,
    payload
})


export const RemoveHolidayRequestAction = (payload: string): RemoveHolidayRequest => ({
    type: Types.REMOVE_HOLIDAY_REQUEST,
    payload

})

export const RemoveHolidaySuccessAction = (): RemoveHolidaySuccess => ({
    type: Types.REMOVE_HOLIDAY_SUCCESS,
})

export const RemoveHolidayErrorAction = (payload: ErrorPayLoad): RemoveHolidayError => ({
    type: Types.REMOVE_HOLIDAY_ERROR,
    payload
})


export const ResetHolidayPropsAction = () => ({
    type: Types.RESET_HOLIDAY_PROPS,

})
